import { defineMessages } from 'react-intl';

// Query type identifiers for batch data fetching in TradeList. Produced by
// `BatchQueryError` in `dataBatching.jsx` and surfaced to the consumer via
// `useTradeData` so the fallback UI can render a query-specific message.
// The helper is feature-agnostic and each feature supplies its own `messages`.

export const TRADE_LIST_QUERY_TYPES = Object.freeze({
  METERS: 'metersQuery',
  RULES: 'rulesQuery',
  TRADES: 'tradesQuery',
});

export const messages = defineMessages({
  [TRADE_LIST_QUERY_TYPES.METERS]: {
    id: 'trade.trade_list.trade_list_table.helpers.error_modal.meters_query.body.message',
    defaultMessage: 'An error occurred while loading meters. Please try again.',
  },
  [TRADE_LIST_QUERY_TYPES.RULES]: {
    id: 'trade.trade_list.trade_list_table.helpers.error_modal.rules_query.body.message',
    defaultMessage: 'An error occurred while loading rules. Please try again.',
  },
  [TRADE_LIST_QUERY_TYPES.TRADES]: {
    id: 'trade.trade_list.trade_list_table.helpers.error_modal.trades_query.body.message',
    defaultMessage: 'An error occurred while loading trades. Please try again.',
  },
});
